import { createContext } from 'react';

const LoginContext = createContext();
export default LoginContext;



// WEBPACK FOOTER //
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Login/loginContext.js